<template>
  <t-modal
    v-model="isVisible"
    @closed="onModalClosed"
  >
    <div class="flex justify-between items-center mb-3">
      <h2>{{ user.display_name }}</h2>
      <div class="flex items-center">
        <!-- TODO: add functionality of pinging a user -->
        <button
          class="storefront-btn-blue"
          :class="{'mr-3': user.icon}"
          type="button"
          aria-label="Ping this user"
          @click="onCreatePing"
        >
          <svg-vue
            icon="salesium-logo-plain"
            class="fill-white h-5 w-5 inline-block mr-3"
          />
          <span class="inline-block text-hint">Ping</span>

        </button>
        <svg-vue
          v-if="user.icon"
          :icon="user.icon"
          class="h-8 w-8 fill-salesium-grey-100"
        />
      </div>

    </div>
    <div class="flex h-32 relative mb-6">
      <div
        class="w-full h-3/5 bg-center bg-cover"
        :style="{backgroundImage: 'url(' + bannerImage + ')'}"
      ></div>
      <div class="absolute inset-y-1/4 left-8 h-40">
        <!-- <svg-vue
          icon="avatar"
          class="h-20 w-20 default-avatar-icon hover:cursor-default"
        /> -->
        <img
          :src="user.avatar_uri" 
          alt="User"
          class="h-24 w-24 default-avatar-icon hover:cursor-default"
          :class="user.type=='pro'? (user.care_score>3? (user.care_score>=5? 'badgeBlue' : 'badgeGreen') : '' ): ''"
        />
      </div>
    </div>

    <div v-if="modalVisible" class="flex w-full h-fit">
      <!-- TODO: only display information the user has decided to display -->
      <div class="w-5/12 h-fit">
        <h3 class="text-xl mb-2">Contact Info</h3>

        <div class="mb-3">
          <p class="font-bold">Telephone:</p>
          <p>123-456-7890</p>
        </div>

        <div class="mb-3">
          <p class="font-bold">Mobile:</p>
          <p>123-456-7890</p>
        </div>

        <div class="mb-3">
          <p class="font-bold">Primary Email:</p>
          <a
            :href="'mailto:' + user.primary_email.value"
            :title="'Send and email to' + user.primary_email.value"
          >
            {{user.primary_email.value}}
          </a>
        </div>

        <div class="mb-3">
          <p class="font-bold">Secondary Email:</p>
          <!-- <a :href="`mailto:${user.secondaryEmail}`" :title="`Send and email to ${user.secondaryEmail}.`">{{ user.secondaryEmail }}</a> -->
          <a
            :href="`mailto:secondary@johndoe.com`"
            :title="`Send and email to secondary@johndow.com.`"
          >secondary@johndoe.com</a>
        </div>

        <div>
          <p class="font-bold">Address:</p>
          <p>123 Example Street</p>
          <p>City, State, 12345</p>
        </div>

      </div>
      <span class="border-l border border-salesium-grey-100 ml-5 mr-5 hidden lg:block"></span>
      <div class="w-1/2 h-40">
        <h3 class="text-xl mb-2">Hours</h3>
        <div class="mb-2">
          <!-- TODO: user hour rows from t66 to show hours -->
          <HourRow
            v-for="day in days"
            :key="day"
            :label="day"
            :start="hours[day.toLowerCase()].start"
            :end="hours[day.toLowerCase()].end"
            :closed="hours[day.toLowerCase()].closed"
          />
        </div>
        <div>
          <p class="text-bold mb-3">Connected Social Media:</p>
          <!-- TODO: show social media icons based on user's preferences -->
          <div class="flex flex-wrap">
            <a
              href="//www.facebook.com"
              target="_blank"
              title="Visit user's Facebook"
              class="mr-4"
            >
              <svg-vue
                class="h-6 fill-salesium-red"
                icon="facebook-f-brands"
                alt="Facebook"
              />
            </a>

            <a
              href="//www.linkedin.com"
              target="_blank"
              title="Visit user's LinkedIn"
              class="mr-4"
            >
              <svg-vue
                class="h-6 fill-salesium-red"
                icon="linkedin-in-brands"
                alt="LinkedIn"
              />
            </a>

            <a
              href="//www.twitter.com"
              target="_blank"
              title="Visit user's Twitter"
              class="mr-4"
            >
              <svg-vue
                class="h-6 fill-salesium-red"
                icon="twitter-brands"
                alt="Twitter"
              />
            </a>

            <a
              href="//www.instagram.com"
              target="_blank"
              title="Visit user's Instagram"
              class="mr-4"
            >
              <svg-vue
                class="h-6 fill-salesium-red"
                icon="instagram-brands"
                alt="Instagram"
              />
            </a>

            <a
              href="//www.pinterest.com"
              target="_blank"
              title="Visit user's Pinterest"
              class="mr-4"
            >
              <svg-vue
                class="h-6 fill-salesium-red"
                icon="pinterest-p-brands"
                alt="Pinterest"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </t-modal>
</template>

<script>
import HourRow from '../../Utils/HourRow.vue';
import { hours } from '../../../testData';
import { days } from '../../../constants/days';
export default {
    props: ['modalVisible', 'user'],
    // TODO: dynamically display all user info
    data() {
        return {
            isVisible: this.modalVisible,
            content: '',
            bannerImage: '/images/example-banner.png',
            days: days,
            hours: hours,
        };
    },
    watch: {
        modalVisible() {
            if (this.isVisible !== this.modalVisible) {
                this.isVisible = this.modalVisible;
            }
        },
    },
    methods: {
        onModalClosed() {
            this.$emit('modalHidden');
        },
        onCreatePing() {
            this.$emit('openPingModal', this.user);
        },
    },
    components: {
        HourRow,
    },
};
</script>
